import { useState } from 'react';

import { useIntl } from 'react-intl';

import { ColorSamples } from '@components/overlays/ColorSamples';

import { IProps } from './types';
import * as S from './styles';

export const ColorSamplesButton: React.FC<IProps> = ({ colorSample }) => {
  const intl = useIntl();
  const [show, setShow] = useState(false);

  if (colorSample && colorSample.length > 0) {
    return (
      <S.Wrapper>
        <ColorSamples
          hide={() => setShow(false)}
          show={show}
          colorSample={colorSample}
        />
        <S.Button type="button" onClick={() => setShow(true)}>
          <S.Text>
            {intl.formatMessage({
              defaultMessage: 'Order color samples',
              id: 'YAW0Qz',
            })}
          </S.Text>
        </S.Button>
      </S.Wrapper>
    );
  }

  return null;
};
